import { jsx as e, jsxs as l, Fragment as q } from "react/jsx-runtime";
import B, { useState as x, useEffect as A, useReducer as de, createContext as ue, useContext as me } from "react";
import { Button as f, Drawer as he, Input as I, Modal as G, Select as P, Table as j, Form as h, message as y, Space as E, Popconfirm as pe, DatePicker as ye, Tooltip as V, Image as ee, Typography as k, Tag as be, Checkbox as ge, Progress as fe, InputNumber as te, Breadcrumb as ke, Row as M, Col as Z, Spin as Ce, Alert as Se, Descriptions as T } from "antd";
import { useNavigate as J, Link as w, useLocation as ve, useSearchParams as Ie, useParams as xe } from "react-router-dom";
import { useQueryClient as D, useMutation as N, useQuery as L } from "@tanstack/react-query";
import { createCustomer as re, updateCustomer as ae, fetchCustomers as Pe, deleteCustomer as _e, createOrder as Te, searchProducts as Ne, mapProductSearchFormValues as we, findProductById as qe, searchDeals as De, findDeal as Fe } from "@digiwedge/axiz_api";
import Oe from "moment";
import { ClockCircleOutlined as Be, ShoppingCartOutlined as Ee, LockOutlined as Ae, StopOutlined as Le } from "@ant-design/icons";
import { ProductVariantModal as Re } from "@digiwedge/ui-antd";
function $e(t) {
  const { children: r, ...a } = t;
  return /* @__PURE__ */ e(f, { ...a, children: r });
}
const jt = (t) => /* @__PURE__ */ e(he, { ...t }), Ht = (t) => /* @__PURE__ */ e(I, { ...t }), Yt = (t) => /* @__PURE__ */ e(G, { ...t }), Zt = (t) => /* @__PURE__ */ e(P, { ...t }), Gt = (t) => {
  const { onSelectionChange: r, rowSelection: a, ...n } = t, c = r || a ? { ...a, onChange: (d, i, m) => {
    a?.onChange?.(d, i, m), r?.(d);
  } } : void 0;
  return /* @__PURE__ */ e(j, { ...n, rowSelection: c });
}, { Option: $ } = P, Y = () => ({
  id: 0,
  customerId: 0,
  fullName: "",
  email: "",
  phoneNumber: ""
}), Qe = ({ visible: t, onClose: r, initialValues: a }) => {
  const [n] = h.useForm(), [o, c] = x(!1), d = D();
  A(() => {
    a ? n.setFieldsValue({
      ...a,
      contactPerson: a.contactPerson || Y()
    }) : n.resetFields();
  }, [a, n]);
  const i = N({
    mutationFn: re,
    onSuccess: () => {
      d.invalidateQueries({ queryKey: ["customers"] }), y.success("Customer created successfully!"), r();
    },
    onError: (b) => {
      y.error(b.message);
    }
  }), m = N({
    mutationFn: ae,
    onSuccess: () => {
      d.invalidateQueries({ queryKey: ["customers"] }), y.success("Customer updated successfully!"), r();
    },
    onError: (b) => {
      y.error(b.message);
    }
  });
  return /* @__PURE__ */ e(
    G,
    {
      title: a ? "Edit Customer" : "Create Customer",
      open: t,
      onCancel: r,
      footer: null,
      destroyOnClose: !0,
      children: /* @__PURE__ */ l(h, { form: n, layout: "vertical", onFinish: async (b) => {
        c(!0);
        try {
          a ? await m.mutateAsync({
            customer: { ...a, ...b },
            customerAddress: a.customerAddresses?.[0] || {
              addressLine1: "",
              city: "",
              postalCode: "",
              countryCode: ""
            },
            customerContactPerson: a.contactPerson || Y()
          }) : await i.mutateAsync({
            customer: b,
            customerAddress: {
              addressLine1: "",
              city: "",
              postalCode: "",
              countryCode: ""
            },
            customerContactPerson: Y()
          });
        } catch (g) {
          console.error("Unexpected error:", g), y.error("An unexpected error occurred.");
        } finally {
          c(!1);
        }
      }, children: [
        /* @__PURE__ */ e(
          h.Item,
          {
            name: "name",
            label: /* @__PURE__ */ e("label", { id: "name-label", htmlFor: "name-input", children: "Customer Name" }),
            rules: [{ required: !0, message: "Customer name is required" }],
            children: /* @__PURE__ */ e(I, { id: "name-input", "aria-labelledby": "name-label", placeholder: "Enter customer name" })
          }
        ),
        /* @__PURE__ */ e(
          h.Item,
          {
            name: "accountNumber",
            label: /* @__PURE__ */ e("label", { id: "accountNumber-label", htmlFor: "accountNumber-input", children: "Account Number" }),
            rules: [{ required: !0, message: "Account number is required" }],
            children: /* @__PURE__ */ e(
              I,
              {
                id: "accountNumber-input",
                "aria-labelledby": "accountNumber-label",
                placeholder: "Enter account number"
              }
            )
          }
        ),
        /* @__PURE__ */ e(
          h.Item,
          {
            name: "customerReference",
            label: /* @__PURE__ */ e("label", { id: "customerReference-label", htmlFor: "customerReference-input", children: "Customer Reference" }),
            children: /* @__PURE__ */ e(
              I,
              {
                id: "customerReference-input",
                "aria-labelledby": "customerReference-label",
                placeholder: "Enter reference (optional)"
              }
            )
          }
        ),
        /* @__PURE__ */ e(
          h.Item,
          {
            name: "email",
            label: /* @__PURE__ */ e("label", { id: "email-label", htmlFor: "email-input", children: "Email" }),
            rules: [
              { required: !0, message: "Email is required" },
              { type: "email", message: "Enter a valid email" }
            ],
            children: /* @__PURE__ */ e(I, { id: "email-input", "aria-labelledby": "email-label", placeholder: "Enter email address" })
          }
        ),
        /* @__PURE__ */ e(
          h.Item,
          {
            name: "phoneNumber",
            label: /* @__PURE__ */ e("label", { id: "phoneNumber-label", htmlFor: "phoneNumber-input", children: "Phone Number" }),
            rules: [
              { required: !0, message: "Phone number is required" },
              { pattern: /^[0-9]+$/, message: "Only digits allowed" }
            ],
            children: /* @__PURE__ */ e(
              I,
              {
                id: "phoneNumber-input",
                "aria-labelledby": "phoneNumber-label",
                placeholder: "Enter phone number"
              }
            )
          }
        ),
        /* @__PURE__ */ e(
          h.Item,
          {
            name: "customerType",
            label: /* @__PURE__ */ e("label", { id: "customerType-label", htmlFor: "customerType-input", children: "Customer Type" }),
            rules: [{ required: !0, message: "Please select a customer type" }],
            children: /* @__PURE__ */ l(
              P,
              {
                id: "customerType-input",
                "aria-labelledby": "customerType-label",
                placeholder: "Select customer type",
                children: [
                  /* @__PURE__ */ e($, { value: "individual", children: "Individual" }),
                  /* @__PURE__ */ e($, { value: "business", children: "Business" })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ e(
          h.Item,
          {
            name: "status",
            label: /* @__PURE__ */ e("label", { id: "status-label", htmlFor: "status-input", children: "Status" }),
            rules: [{ required: !0, message: "Please select a status" }],
            children: /* @__PURE__ */ l(P, { id: "status-input", "aria-labelledby": "status-label", placeholder: "Select status", children: [
              /* @__PURE__ */ e($, { value: "active", children: "Active" }),
              /* @__PURE__ */ e($, { value: "inactive", children: "Inactive" })
            ] })
          }
        ),
        /* @__PURE__ */ l(h.Item, { children: [
          /* @__PURE__ */ e(
            f,
            {
              type: "primary",
              htmlType: "submit",
              loading: o,
              "aria-label": a ? "Update customer" : "Create customer",
              children: a ? "Update Customer" : "Create Customer"
            }
          ),
          /* @__PURE__ */ e(f, { style: { marginLeft: 8 }, onClick: r, "aria-label": "Cancel", children: "Cancel" })
        ] })
      ] })
    }
  );
}, Jt = ({ visible: t, onClose: r, initialValues: a }) => /* @__PURE__ */ e(
  G,
  {
    title: a ? "Edit Customer" : "Create Customer",
    open: t,
    onCancel: r,
    footer: null,
    destroyOnClose: !0,
    forceRender: !0,
    children: /* @__PURE__ */ e(Qe, { onClose: r, initialValues: a, visible: !1 })
  }
), Me = () => L({
  queryKey: ["customers"],
  queryFn: async () => await Pe({}) || [],
  staleTime: 1e3 * 60 * 5
  // Cache for 5 minutes
}), Wt = () => {
  const t = D();
  return N({
    mutationFn: re,
    onMutate: async (r) => {
      await t.cancelQueries({ queryKey: ["customers"] });
      const a = t.getQueryData(["customers"]);
      return t.setQueryData(
        ["customers"],
        (n) => n ? [...n, r] : [r]
      ), { previousCustomers: a };
    },
    onError: (r, a, n) => {
      n?.previousCustomers && t.setQueryData(["customers"], n.previousCustomers), y.error(r instanceof Error ? r.message : "Failed to create customer.");
    },
    onSettled: () => {
      t.invalidateQueries({ queryKey: ["customers"] });
    },
    onSuccess: () => {
      y.success("Customer created successfully!");
    }
  });
}, Vt = () => {
  const t = D();
  return N({
    mutationFn: ae,
    onMutate: async (r) => {
      await t.cancelQueries({ queryKey: ["customers"] });
      const a = t.getQueryData(["customers"]);
      return t.setQueryData(
        ["customers"],
        (n) => n?.map(
          (o) => o.id === r.id ? r : o
        ) || []
      ), { previousCustomers: a };
    },
    onError: (r, a, n) => {
      n?.previousCustomers && t.setQueryData(["customers"], n.previousCustomers), y.error(r instanceof Error ? r.message : "Failed to update customer.");
    },
    onSettled: () => {
      t.invalidateQueries({ queryKey: ["customers"] });
    },
    onSuccess: () => {
      y.success("Customer updated successfully!");
    }
  });
}, Ue = () => {
  const t = D();
  return N({
    mutationFn: (r) => _e(Number(r)),
    onMutate: async (r) => {
      await t.cancelQueries({ queryKey: ["customers"] });
      const a = t.getQueryData(["customers"]);
      return t.setQueryData(
        ["customers"],
        (n) => n?.filter((o) => o.id !== Number(r)) || []
      ), { previousCustomers: a };
    },
    onError: (r, a, n) => {
      n?.previousCustomers && t.setQueryData(["customers"], n.previousCustomers), y.error(r instanceof Error ? r.message : "Failed to delete customer.");
    },
    onSettled: () => {
      t.invalidateQueries({ queryKey: ["customers"] });
    },
    onSuccess: () => {
      y.success("Customer deleted successfully!");
    }
  });
}, Xt = () => {
  const { data: t, isLoading: r } = Me(), a = Ue(), n = async (c) => {
    try {
      await a.mutateAsync(c), y.success("Customer deleted successfully!");
    } catch (d) {
      y.error(d instanceof Error ? d.message : "Failed to delete customer.");
    }
  };
  return /* @__PURE__ */ e(
    j,
    {
      dataSource: t ?? [],
      columns: [
        { title: "Customer Name", dataIndex: "name", key: "name" },
        { title: "Account Number", dataIndex: "accountNumber", key: "accountNumber" },
        {
          title: "Actions",
          key: "actions",
          render: (c) => /* @__PURE__ */ e(E, { children: /* @__PURE__ */ e(
            pe,
            {
              title: "Are you sure?",
              onConfirm: () => n(c.id),
              okText: "Yes",
              cancelText: "No",
              children: /* @__PURE__ */ e(f, { danger: !0, disabled: a.isPending, "aria-label": "Delete customer", children: "Delete" })
            }
          ) })
        }
      ],
      rowKey: (c) => c.id,
      loading: r
    }
  );
}, er = ({ onFilter: t }) => {
  const [r] = h.useForm();
  return /* @__PURE__ */ l(h, { form: r, layout: "inline", onFinish: (n) => {
    const o = {
      ...n,
      discountPercentage: n.discountPercentage ? Number(n.discountPercentage) : void 0,
      validUntil: n.validUntil ? Oe(n.validUntil) : void 0
    }, c = Object.fromEntries(
      Object.entries(o).filter(([d, i]) => i !== void 0 && i !== "")
    );
    t(c);
  }, children: [
    /* @__PURE__ */ e(
      h.Item,
      {
        name: "title",
        label: /* @__PURE__ */ e("label", { id: "dealTitle-label", htmlFor: "dealTitle-input", children: "Deal Title" }),
        children: /* @__PURE__ */ e(
          I,
          {
            id: "dealTitle-input",
            "aria-labelledby": "dealTitle-label",
            placeholder: "Enter deal title"
          }
        )
      }
    ),
    /* @__PURE__ */ e(
      h.Item,
      {
        name: "discountPercentage",
        label: /* @__PURE__ */ e("label", { id: "discountPercentage-label", htmlFor: "discountPercentage-input", children: "Discount (%)" }),
        children: /* @__PURE__ */ e(
          I,
          {
            id: "discountPercentage-input",
            "aria-labelledby": "discountPercentage-label",
            type: "number",
            placeholder: "Min discount"
          }
        )
      }
    ),
    /* @__PURE__ */ e(
      h.Item,
      {
        name: "validUntil",
        label: /* @__PURE__ */ e("label", { id: "validUntil-label", htmlFor: "validUntil-input", children: "Valid Until" }),
        children: /* @__PURE__ */ e(ye, { id: "validUntil-input", "aria-labelledby": "validUntil-label", format: "YYYY-MM-DD" })
      }
    ),
    /* @__PURE__ */ e(h.Item, { children: /* @__PURE__ */ l(E, { children: [
      /* @__PURE__ */ e(f, { type: "primary", htmlType: "submit", "aria-label": "Search deals", children: "Search" }),
      /* @__PURE__ */ e(
        f,
        {
          onClick: () => r.resetFields(["title", "discountPercentage", "validUntil"]),
          "aria-label": "Reset filters",
          children: "Reset"
        }
      )
    ] }) })
  ] });
}, tr = ({ deals: t = [], loading: r }) => /* @__PURE__ */ e(
  j,
  {
    dataSource: t,
    "aria-label": "Deals table",
    loading: r,
    locale: { emptyText: "No deals available" },
    columns: [
      { title: "Title", dataIndex: "title", key: "title" },
      {
        title: "Discount (%)",
        dataIndex: "discountPercentage",
        key: "discountPercentage"
      },
      { title: "Valid Until", dataIndex: "validUntil", key: "validUntil" }
    ],
    rowKey: (n) => n.dealId
  }
), ne = "yolo-cart", Ke = () => {
  if (typeof window > "u") return [];
  try {
    const t = localStorage.getItem(ne);
    if (t) {
      const r = JSON.parse(t);
      return Array.isArray(r) ? r : [];
    }
  } catch {
  }
  return [];
}, ze = (t) => {
  if (!(typeof window > "u"))
    try {
      localStorage.setItem(ne, JSON.stringify(t));
    } catch {
    }
}, oe = ue(null), U = (t, r) => {
  const a = Number.isFinite(t) ? t : 1;
  return a <= 0 || typeof r == "number" && r <= 0 ? 0 : Math.max(1, Math.min(a, typeof r == "number" ? r : 1 / 0));
}, je = (t) => t.reduce((r, a) => {
  const n = U(a.quantity, a.product.availableToSell);
  return n <= 0 || r.push({ ...a, quantity: n }), r;
}, []);
function He(t, r) {
  switch (r.type) {
    case "add": {
      const a = t.items.find(
        (o) => o.product.productIdentifier === r.item.product.productIdentifier
      );
      if (a) {
        const o = a.quantity + r.item.quantity, c = U(o, a.product.availableToSell);
        return c <= 0 ? {
          items: t.items.filter(
            (d) => d.product.productIdentifier !== r.item.product.productIdentifier
          )
        } : {
          items: t.items.map(
            (d) => d.product.productIdentifier === r.item.product.productIdentifier ? { ...d, quantity: c } : d
          )
        };
      }
      const n = U(r.item.quantity, r.item.product.availableToSell);
      return n <= 0 ? t : { items: [...t.items, { ...r.item, quantity: n }] };
    }
    case "remove":
      return {
        items: t.items.filter((a) => a.product.productIdentifier !== r.identifier)
      };
    case "update": {
      const a = t.items.find((o) => o.product.productIdentifier === r.identifier), n = U(r.quantity, a?.product.availableToSell);
      return n <= 0 ? {
        items: t.items.filter((o) => o.product.productIdentifier !== r.identifier)
      } : {
        items: t.items.map(
          (o) => o.product.productIdentifier === r.identifier ? { ...o, quantity: n } : o
        )
      };
    }
    case "clear":
      return { items: [] };
    case "hydrate":
      return { items: je(r.items) };
    default:
      return t;
  }
}
const rr = ({
  children: t,
  initialItems: r = []
}) => {
  const [a, n] = de(He, { items: r });
  A(() => {
    const p = Ke();
    p.length > 0 && n({ type: "hydrate", items: p });
  }, []), A(() => {
    ze(a.items);
  }, [a.items]);
  const o = B.useCallback((p) => n({ type: "add", item: p }), []), c = B.useCallback(
    (p) => n({ type: "remove", identifier: p }),
    []
  ), d = B.useCallback(
    (p, b) => n({ type: "update", identifier: p, quantity: b }),
    []
  ), i = B.useCallback(() => n({ type: "clear" }), []), m = B.useMemo(
    () => ({
      items: a.items,
      addItem: o,
      removeItem: c,
      updateQuantity: d,
      clear: i
    }),
    [a.items, o, c, d, i]
  );
  return /* @__PURE__ */ e(oe.Provider, { value: m, children: t });
}, F = () => {
  const t = me(oe);
  if (!t) throw new Error("useCart must be used within CartProvider");
  return t;
}, Ye = "_productCard_c1uok_3", Ze = "_imageContainer_c1uok_27", Ge = "_productImage_c1uok_35", Je = "_imagePlaceholder_c1uok_48", We = "_stockBadge_c1uok_65", Ve = "_stockInStock_c1uok_77", Xe = "_stockLowStock_c1uok_82", et = "_stockOutOfStock_c1uok_87", tt = "_stockBackorder_c1uok_92", rt = "_cardBody_c1uok_98", at = "_brandBadge_c1uok_107", nt = "_productTitle_c1uok_118", ot = "_priceSection_c1uok_132", it = "_currentPrice_c1uok_139", lt = "_originalPrice_c1uok_149", ct = "_discountBadge_c1uok_155", st = "_tagsContainer_c1uok_165", dt = "_tag_c1uok_165", ut = "_actionButton_c1uok_185", mt = "_skeletonCard_c1uok_206", ht = "_skeletonImage_c1uok_217", pt = "_skeletonBody_c1uok_225", yt = "_skeletonLine_c1uok_232", bt = "_skeletonLineShort_c1uok_240", gt = "_skeletonLinePrice_c1uok_244", ft = "_skeletonButton_c1uok_250", u = {
  productCard: Ye,
  imageContainer: Ze,
  productImage: Ge,
  imagePlaceholder: Je,
  stockBadge: We,
  stockInStock: Ve,
  stockLowStock: Xe,
  stockOutOfStock: et,
  stockBackorder: tt,
  cardBody: rt,
  brandBadge: at,
  productTitle: nt,
  priceSection: ot,
  currentPrice: it,
  originalPrice: lt,
  discountBadge: ct,
  tagsContainer: st,
  tag: dt,
  actionButton: ut,
  skeletonCard: mt,
  skeletonImage: ht,
  skeletonBody: pt,
  skeletonLine: yt,
  skeletonLineShort: bt,
  skeletonLinePrice: gt,
  skeletonButton: ft
};
function kt(t) {
  return t.availableToSell === 0 ? t.estimatedTimeOfArrival ? "backorder" : "outOfStock" : t.availableToSell <= 5 ? "lowStock" : "inStock";
}
function Ct(t) {
  switch (t) {
    case "inStock":
      return "In Stock";
    case "lowStock":
      return "Low Stock";
    case "outOfStock":
      return "Out of Stock";
    case "backorder":
      return "Backorder";
  }
}
function St(t) {
  switch (t) {
    case "inStock":
      return u.stockInStock;
    case "lowStock":
      return u.stockLowStock;
    case "outOfStock":
      return u.stockOutOfStock;
    case "backorder":
      return u.stockBackorder;
  }
}
function X(t, r = "ZAR") {
  return new Intl.NumberFormat("en-ZA", {
    style: "currency",
    currency: r,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(t);
}
function vt() {
  return /* @__PURE__ */ l("div", { className: u.skeletonCard, children: [
    /* @__PURE__ */ e("div", { className: u.skeletonImage }),
    /* @__PURE__ */ l("div", { className: u.skeletonBody, children: [
      /* @__PURE__ */ e("div", { className: `${u.skeletonLine} ${u.skeletonLineShort}` }),
      /* @__PURE__ */ e("div", { className: u.skeletonLine }),
      /* @__PURE__ */ e("div", { className: u.skeletonLine }),
      /* @__PURE__ */ e("div", { className: `${u.skeletonLine} ${u.skeletonLinePrice}` }),
      /* @__PURE__ */ e("div", { className: u.skeletonButton })
    ] })
  ] });
}
const ar = ({
  product: t,
  isAuthenticated: r = !0,
  loading: a = !1
}) => {
  const n = J(), { addItem: o } = F(), [c, d] = x(!1), [i, m] = x(!1), [p, b] = x(!1);
  if (a)
    return /* @__PURE__ */ e(vt, {});
  const g = kt(t), O = r && g !== "outOfStock", s = t.tags ? [...new Set(t.tags.flatMap((S) => Object.values(S)))] : [], _ = t.discount && t.discount > 0, R = _ ? t.price + (t.discount ?? 0) : null, C = () => {
    n(
      `/products/${t.brandInfo.brandId}/${t.productIdentifier}/${t.market}`
    );
  }, W = (S) => {
    S.stopPropagation(), O && (t.sizes && t.sizes.length > 0 ? d(!0) : o({ product: t, quantity: 1 }));
  }, ie = (S) => {
    o({ product: t, quantity: 1, size: S }), d(!1);
  }, le = (S) => {
    (S.key === "Enter" || S.key === " ") && (S.preventDefault(), C());
  }, H = r ? g === "outOfStock" ? { icon: /* @__PURE__ */ e(Le, {}), text: "Out of stock" } : null : { icon: /* @__PURE__ */ e(Ae, {}), text: "Login required" }, ce = () => g === "backorder" ? /* @__PURE__ */ e(V, { title: `Available ${t.estimatedTimeOfArrival || "soon"}`, children: /* @__PURE__ */ e(
    f,
    {
      type: "primary",
      className: u.actionButton,
      icon: /* @__PURE__ */ e(Be, {}),
      onClick: W,
      children: "Backorder"
    }
  ) }) : !O && H ? /* @__PURE__ */ e(V, { title: H.text, children: /* @__PURE__ */ e(
    f,
    {
      type: "primary",
      className: u.actionButton,
      disabled: !0,
      icon: H.icon,
      children: "Add to Cart"
    }
  ) }) : /* @__PURE__ */ e(
    f,
    {
      type: "primary",
      className: u.actionButton,
      icon: /* @__PURE__ */ e(Ee, {}),
      onClick: W,
      children: "Add to Cart"
    }
  );
  return /* @__PURE__ */ l(
    "div",
    {
      className: u.productCard,
      role: "button",
      tabIndex: 0,
      "aria-label": `View details for ${t.name}`,
      onClick: C,
      onKeyDown: le,
      children: [
        /* @__PURE__ */ l("div", { className: u.imageContainer, children: [
          !i && !p && /* @__PURE__ */ e("div", { className: u.imagePlaceholder }),
          /* @__PURE__ */ e(
            "img",
            {
              src: t.imageUrl || "/assets/product-placeholder.svg",
              alt: t.name,
              className: u.productImage,
              loading: "lazy",
              style: { display: i ? "block" : "none" },
              onLoad: () => m(!0),
              onError: () => {
                b(!0), m(!0);
              }
            }
          ),
          p && /* @__PURE__ */ e(
            "img",
            {
              src: "/assets/product-placeholder.svg",
              alt: t.name,
              className: u.productImage
            }
          ),
          /* @__PURE__ */ e("span", { className: `${u.stockBadge} ${St(g)}`, children: Ct(g) })
        ] }),
        /* @__PURE__ */ l("div", { className: u.cardBody, children: [
          /* @__PURE__ */ e("span", { className: u.brandBadge, children: t.brandInfo.brandName }),
          /* @__PURE__ */ e("h3", { className: u.productTitle, title: t.name, children: t.name }),
          s.length > 0 && /* @__PURE__ */ e("div", { className: u.tagsContainer, children: s.slice(0, 3).map((S, se) => /* @__PURE__ */ e("span", { className: u.tag, children: S }, se)) }),
          /* @__PURE__ */ l("div", { className: u.priceSection, children: [
            /* @__PURE__ */ e("span", { className: u.currentPrice, children: X(t.price, t.currencyCode || "ZAR") }),
            _ && R && /* @__PURE__ */ l(q, { children: [
              /* @__PURE__ */ e("span", { className: u.originalPrice, children: X(R, t.currencyCode || "ZAR") }),
              t.discountPercentage && /* @__PURE__ */ l("span", { className: u.discountBadge, children: [
                "-",
                t.discountPercentage,
                "%"
              ] })
            ] })
          ] }),
          ce()
        ] }),
        t.sizes && t.sizes.length > 0 && /* @__PURE__ */ e(
          Re,
          {
            open: c,
            sizes: t.sizes,
            onAdd: ie,
            onCancel: () => d(!1)
          }
        )
      ]
    }
  );
}, It = ({
  products: t,
  loading: r,
  pageIndex: a,
  pageSize: n,
  onPageChange: o
}) => {
  const c = J(), d = [
    {
      title: "Image",
      dataIndex: "imageUrl",
      key: "imageUrl",
      render: (i) => i ? /* @__PURE__ */ e(ee, { width: 50, src: i, alt: "Product" }) : /* @__PURE__ */ e(k.Text, { type: "secondary", children: "No Image" })
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (i) => /* @__PURE__ */ e(k.Text, { strong: !0, children: i })
    },
    { title: "Brand", dataIndex: ["brandInfo", "brandName"], key: "brand" },
    { title: "Category", dataIndex: "category", key: "category" },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      render: (i) => /* @__PURE__ */ l(k.Text, { strong: !0, children: [
        "R ",
        i
      ] })
    },
    {
      title: "Tags",
      dataIndex: "tags",
      key: "tags",
      render: (i) => i?.length ? i.map((m) => /* @__PURE__ */ e(be, { children: m.key }, m.key)) : /* @__PURE__ */ e(k.Text, { type: "secondary", children: "No Tags" })
    }
  ];
  return /* @__PURE__ */ e(
    j,
    {
      dataSource: t,
      "aria-label": "Product list",
      loading: r,
      locale: { emptyText: "No products found" },
      rowKey: "productIdentifier",
      pagination: {
        current: a + 1,
        pageSize: n,
        onChange: (i, m) => o(i - 1, m)
      },
      onRow: (i) => ({
        role: "link",
        tabIndex: 0,
        "aria-label": `View details for ${i.name || i.productIdentifier}`,
        onClick: () => c(
          `/products/${i.brandInfo.brandId}/${i.productIdentifier}/${i.market}`
        ),
        onKeyDown: (m) => {
          m.key === "Enter" && (m.preventDefault(), c(
            `/products/${i.brandInfo.brandId}/${i.productIdentifier}/${i.market}`
          ));
        },
        onKeyUp: (m) => {
          m.key === " " && (m.preventDefault(), c(
            `/products/${i.brandInfo.brandId}/${i.productIdentifier}/${i.market}`
          ));
        }
      }),
      columns: d
    }
  );
}, { Option: v } = P, xt = ({ onSearch: t, initialValues: r }) => {
  const [a] = h.useForm();
  return A(() => {
    r && a.setFieldsValue(r);
  }, [a, r]), /* @__PURE__ */ e(
    h,
    {
      form: a,
      layout: "vertical",
      onFinish: (o) => {
        t(o);
      },
      initialValues: { market: 14, sortOptions: "name", ...r },
      children: /* @__PURE__ */ l(E, { orientation: "vertical", size: "middle", style: { width: "100%" }, children: [
        /* @__PURE__ */ e(
          h.Item,
          {
            name: "searchText",
            label: /* @__PURE__ */ e("label", { id: "searchText-label", htmlFor: "searchText-input", children: "Search" }),
            children: /* @__PURE__ */ e(
              I,
              {
                id: "searchText-input",
                "aria-labelledby": "searchText-label",
                placeholder: "Enter product name or SKU",
                allowClear: !0
              }
            )
          }
        ),
        /* @__PURE__ */ e(
          h.Item,
          {
            name: "market",
            label: /* @__PURE__ */ e("label", { id: "market-label", htmlFor: "market-input", children: "Market" }),
            children: /* @__PURE__ */ l(
              P,
              {
                id: "market-input",
                "aria-labelledby": "market-label",
                placeholder: "Select market",
                style: { width: "100%" },
                children: [
                  /* @__PURE__ */ e(v, { value: 14, children: "Cisco" }),
                  /* @__PURE__ */ e(v, { value: 4, children: "General Store" })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ e(
          h.Item,
          {
            name: "brand",
            label: /* @__PURE__ */ e("label", { id: "brand-label", htmlFor: "brand-input", children: "Brand" }),
            children: /* @__PURE__ */ l(
              P,
              {
                id: "brand-input",
                "aria-labelledby": "brand-label",
                placeholder: "Select brand",
                style: { width: "100%" },
                allowClear: !0,
                children: [
                  /* @__PURE__ */ e(v, { value: "Dell", children: "Dell" }),
                  /* @__PURE__ */ e(v, { value: "HP", children: "HP" }),
                  /* @__PURE__ */ e(v, { value: "Lenovo", children: "Lenovo" })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ e(
          h.Item,
          {
            name: "category",
            label: /* @__PURE__ */ e("label", { id: "category-label", htmlFor: "category-input", children: "Category" }),
            children: /* @__PURE__ */ l(
              P,
              {
                id: "category-input",
                "aria-labelledby": "category-label",
                placeholder: "Select category",
                style: { width: "100%" },
                allowClear: !0,
                children: [
                  /* @__PURE__ */ e(v, { value: "Laptops", children: "Laptops" }),
                  /* @__PURE__ */ e(v, { value: "Desktops", children: "Desktops" }),
                  /* @__PURE__ */ e(v, { value: "Accessories", children: "Accessories" })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ e(h.Item, { label: "Price Range", children: /* @__PURE__ */ l(E, { children: [
          /* @__PURE__ */ e(h.Item, { name: "priceMin", noStyle: !0, children: /* @__PURE__ */ e(I, { type: "number", placeholder: "Min" }) }),
          /* @__PURE__ */ e(h.Item, { name: "priceMax", noStyle: !0, children: /* @__PURE__ */ e(I, { type: "number", placeholder: "Max" }) })
        ] }) }),
        /* @__PURE__ */ e(
          h.Item,
          {
            name: "tags",
            label: /* @__PURE__ */ e("label", { id: "tags-label", htmlFor: "tags-input", children: "Tags" }),
            children: /* @__PURE__ */ e(
              P,
              {
                id: "tags-input",
                "aria-labelledby": "tags-label",
                mode: "tags",
                placeholder: "Add tags",
                style: { width: "100%" }
              }
            )
          }
        ),
        /* @__PURE__ */ e(h.Item, { name: "availability", valuePropName: "checked", children: /* @__PURE__ */ e(ge, { "aria-label": "In stock only", children: "In Stock Only" }) }),
        /* @__PURE__ */ e(
          h.Item,
          {
            name: "sortOptions",
            label: /* @__PURE__ */ e("label", { id: "sortOptions-label", htmlFor: "sortOptions-input", children: "Sort By" }),
            children: /* @__PURE__ */ l(
              P,
              {
                id: "sortOptions-input",
                "aria-labelledby": "sortOptions-label",
                placeholder: "Select sort order",
                style: { width: "100%" },
                children: [
                  /* @__PURE__ */ e(v, { value: "name", children: "Name (A-Z)" }),
                  /* @__PURE__ */ e(v, { value: "priceAsc", children: "Price (Low to High)" }),
                  /* @__PURE__ */ e(v, { value: "priceDesc", children: "Price (High to Low)" })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ e(h.Item, { children: /* @__PURE__ */ l(E, { children: [
          /* @__PURE__ */ e(f, { type: "primary", htmlType: "submit", "aria-label": "Search products", children: "Search" }),
          /* @__PURE__ */ e(f, { onClick: () => a.resetFields(), "aria-label": "Reset search filters", children: "Reset" })
        ] }) })
      ] })
    }
  );
}, Pt = ({ item: t }) => {
  const { removeItem: r } = F();
  return /* @__PURE__ */ l(
    "div",
    {
      style: {
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "8px 0",
        borderBottom: "1px solid #f0f0f0"
      },
      children: [
        /* @__PURE__ */ l("div", { style: { flex: 1 }, children: [
          /* @__PURE__ */ e("div", { children: t.product.name }),
          /* @__PURE__ */ l("div", { style: { color: "#8c8c8c" }, children: [
            "Qty: ",
            t.quantity
          ] })
        ] }),
        /* @__PURE__ */ l("div", { style: { whiteSpace: "nowrap" }, children: [
          "R ",
          t.product.price * t.quantity
        ] }),
        /* @__PURE__ */ e(
          f,
          {
            onClick: () => r(t.product.productIdentifier),
            "aria-label": `Remove ${t.product.name} from cart`,
            children: "Remove"
          },
          t.product.productIdentifier
        )
      ]
    }
  );
}, nr = () => {
  const { items: t } = F();
  return t.length ? /* @__PURE__ */ e("div", { role: "list", children: t.map((r) => /* @__PURE__ */ e("div", { role: "listitem", children: /* @__PURE__ */ e(Pt, { item: r }) }, r.product.productIdentifier)) }) : /* @__PURE__ */ e("div", { children: "Cart is empty" });
}, _t = () => {
  const { items: t } = F(), r = t.reduce((a, n) => a + n.product.price * n.quantity, 0);
  return /* @__PURE__ */ l("div", { children: [
    t.length === 0 ? /* @__PURE__ */ e("div", { children: "Cart is empty" }) : /* @__PURE__ */ e("div", { role: "list", children: t.map((a) => /* @__PURE__ */ l(
      "div",
      {
        role: "listitem",
        style: {
          display: "flex",
          justifyContent: "space-between",
          padding: "6px 0",
          borderBottom: "1px solid #f0f0f0"
        },
        children: [
          /* @__PURE__ */ e(k.Text, { children: a.product.name }),
          /* @__PURE__ */ l(k.Text, { children: [
            "x",
            a.quantity
          ] })
        ]
      },
      a.product.productIdentifier
    )) }),
    /* @__PURE__ */ l(k.Text, { strong: !0, children: [
      "Total: R ",
      r.toFixed(2)
    ] })
  ] });
}, Tt = ({ onCheckout: t }) => {
  const { items: r, clear: a, updateQuantity: n } = F(), [o, c] = x(50);
  return /* @__PURE__ */ l("form", { onSubmit: async (i) => {
    i.preventDefault();
    const m = {
      reference: `web-${Date.now()}`,
      orderDate: (/* @__PURE__ */ new Date()).toISOString(),
      totalAmount: r.reduce((p, b) => p + b.product.price * b.quantity, 0),
      status: "New"
    };
    try {
      c(100), await Te(m), t(), a();
    } catch (p) {
      console.error("Failed to create order:", p), alert("An error occurred while placing your order. Please try again.");
    }
  }, children: [
    /* @__PURE__ */ e(fe, { percent: o, "aria-label": "checkout-progress" }),
    /* @__PURE__ */ e("div", { role: "list", children: r.map((i) => /* @__PURE__ */ l(
      "div",
      {
        role: "listitem",
        style: {
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "8px 0",
          borderBottom: "1px solid #f0f0f0"
        },
        children: [
          /* @__PURE__ */ e("div", { style: { flex: 1 }, children: i.product.name }),
          /* @__PURE__ */ e(
            te,
            {
              "aria-label": `quantity-${i.product.productIdentifier}`,
              min: 1,
              value: i.quantity,
              onChange: (m) => m && n(i.product.productIdentifier, Number(m))
            }
          ),
          /* @__PURE__ */ l("div", { style: { width: 80, textAlign: "right" }, children: [
            "R ",
            i.product.price * i.quantity
          ] })
        ]
      },
      i.product.productIdentifier
    )) }),
    /* @__PURE__ */ l("p", { children: [
      "Total items: ",
      r.reduce((i, m) => i + m.quantity, 0)
    ] }),
    /* @__PURE__ */ e(f, { type: "primary", htmlType: "submit", disabled: !r.length, "aria-label": "Place order", children: "Place Order" })
  ] });
}, or = ({ onComplete: t }) => {
  const [r, a] = x("review");
  return r === "complete" ? /* @__PURE__ */ e("p", { children: "Thank you for your order." }) : /* @__PURE__ */ l("div", { children: [
    r === "review" && /* @__PURE__ */ l(q, { children: [
      /* @__PURE__ */ e(_t, {}),
      /* @__PURE__ */ e(
        $e,
        {
          type: "primary",
          onClick: () => a("details"),
          "aria-label": "Proceed to checkout",
          children: "Proceed to checkout"
        }
      )
    ] }),
    r === "details" && /* @__PURE__ */ e(
      Tt,
      {
        onCheckout: () => {
          a("complete"), t();
        }
      }
    )
  ] });
}, Nt = {
  background: "#001529",
  padding: "10px 16px",
  color: "#fff"
}, wt = {
  display: "flex",
  alignItems: "center",
  gap: "16px"
}, Q = {
  color: "#fff",
  fontWeight: "bold"
}, qt = {
  marginLeft: "auto"
}, Dt = {
  padding: "2px 8px"
}, K = () => {
  const t = J(), [r, a] = x("");
  return /* @__PURE__ */ e("header", { style: Nt, children: /* @__PURE__ */ l("nav", { style: wt, children: [
    /* @__PURE__ */ e(w, { to: "/", style: Q, "aria-label": "Axiz CRM homepage", children: "Axiz CRM" }),
    /* @__PURE__ */ e(w, { to: "/search", style: Q, "aria-label": "Go to search page", children: "Search" }),
    /* @__PURE__ */ e(w, { to: "/cart", style: Q, "aria-label": "View cart", children: "Cart" }),
    /* @__PURE__ */ e(w, { to: "/account", style: Q, "aria-label": "Account settings", children: "Account" }),
    /* @__PURE__ */ l("form", { role: "search", onSubmit: (o) => {
      o.preventDefault();
      const c = r.trim();
      t(c ? `/search?searchText=${encodeURIComponent(c)}` : "/search");
    }, style: qt, children: [
      /* @__PURE__ */ e("label", { htmlFor: "header-search", style: { position: "absolute", left: "-10000px" }, children: "Search products" }),
      /* @__PURE__ */ e(
        "input",
        {
          id: "header-search",
          type: "search",
          value: r,
          onChange: (o) => a(o.target.value),
          "aria-label": "Search products",
          placeholder: "Search...",
          style: Dt
        }
      ),
      /* @__PURE__ */ e("button", { type: "submit", className: "visually-hidden", "aria-label": "Submit search", children: "Search" })
    ] })
  ] }) });
}, z = () => {
  const r = ve().pathname.split("/").filter(Boolean), a = [
    {
      title: /* @__PURE__ */ e(w, { to: "/", "aria-label": "Home", children: "Home" })
    },
    ...r.map((n, o) => {
      const c = `/${r.slice(0, o + 1).join("/")}`;
      return {
        key: c,
        title: /* @__PURE__ */ e(w, { to: c, "aria-label": decodeURIComponent(n), children: decodeURIComponent(n) })
      };
    })
  ];
  return /* @__PURE__ */ e(ke, { style: { margin: "16px 0" }, items: a });
}, Ft = (t, r = 0, a = 10) => L({
  queryKey: ["products", t, r, a],
  queryFn: async () => {
    if (!t) return [];
    try {
      return await Ne({
        ...we(t),
        pageIndex: r,
        maxResultCount: a
      });
    } catch (n) {
      throw y.error("Failed to fetch products. Please try again."), n instanceof Error ? new Error(n.message || "Error fetching products") : new Error("Error fetching products");
    }
  },
  staleTime: 1e3 * 60 * 5,
  // Cache for 5 minutes
  enabled: !!t
  // Prevents API calls if filters are undefined
}), Ot = (t, r, a) => L({
  queryKey: ["productDetails", t, r, a],
  queryFn: async () => {
    if (!t || !r || !a) throw new Error("Missing required parameters");
    try {
      return await qe(t, r, a);
    } catch (n) {
      throw y.error("Failed to fetch product details. Please try again."), n instanceof Error ? new Error(n.message || "Error fetching product details") : new Error("Error fetching product details");
    }
  },
  staleTime: 1e3 * 60 * 10,
  // Cache for 10 minutes
  enabled: !!(t && r && a)
  // Fetch only when parameters exist
}), ir = () => {
  const t = D();
  return () => t.refetchQueries({ queryKey: ["products"] });
}, lr = () => {
  const [t, r] = Ie(), [a, n] = x({}), [o, c] = x(0), [d, i] = x(10);
  A(() => {
    const s = Object.fromEntries(t.entries()), _ = {
      searchText: s.searchText || void 0,
      market: s.market ? Number(s.market) : void 0,
      brand: s.brand || void 0,
      availability: s.availability !== void 0 ? s.availability === "true" : void 0,
      sortOptions: s.sortOptions || void 0
    };
    n(_), c(s.page ? Number(s.page) : 0), i(s.pageSize ? Number(s.pageSize) : 10);
  }, []);
  const m = (s, _ = o, R = d) => {
    const C = {};
    s.searchText && (C.searchText = s.searchText), s.market !== void 0 && (C.market = String(s.market)), s.brand && (C.brand = s.brand), s.availability !== void 0 && (C.availability = String(s.availability)), s.sortOptions && (C.sortOptions = s.sortOptions), C.page = String(_), C.pageSize = String(R), r(C);
  }, { data: p = [], isLoading: b } = Ft(a, o, d);
  return /* @__PURE__ */ l(q, { children: [
    /* @__PURE__ */ e(K, {}),
    /* @__PURE__ */ e(z, {}),
    /* @__PURE__ */ e(M, { justify: "center", children: /* @__PURE__ */ l(Z, { xs: 24, sm: 22, md: 20, lg: 16, xl: 12, children: [
      /* @__PURE__ */ e("h2", { children: "Product Search" }),
      /* @__PURE__ */ e(xt, { onSearch: (s) => {
        n(s), c(0), m(s, 0, d);
      }, initialValues: a }),
      /* @__PURE__ */ e(
        It,
        {
          products: p,
          loading: b,
          pageIndex: o,
          pageSize: d,
          onPageChange: (s, _) => {
            c(s), i(_), m(a, s, _);
          }
        }
      )
    ] }) })
  ] });
}, cr = () => {
  const { brand: t, identifier: r, market: a } = xe(), {
    data: n,
    isLoading: o,
    error: c
  } = Ot(Number(t), r, Number(a)), { addItem: d } = F(), [i, m] = x(1), p = n?.availableToSell !== void 0 ? n.availableToSell <= 0 : !1, b = {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginTop: "20px"
  };
  return o ? /* @__PURE__ */ l(q, { children: [
    /* @__PURE__ */ e(K, {}),
    /* @__PURE__ */ e(z, {}),
    /* @__PURE__ */ e(M, { justify: "center", style: { marginTop: "50px" }, children: /* @__PURE__ */ e(Ce, { size: "large", tip: "Loading product details..." }) })
  ] }) : c || !n ? /* @__PURE__ */ l(q, { children: [
    /* @__PURE__ */ e(K, {}),
    /* @__PURE__ */ e(z, {}),
    /* @__PURE__ */ e(M, { justify: "center", style: { marginTop: "20px" }, children: /* @__PURE__ */ e(Z, { xs: 24, sm: 22, md: 20, lg: 16, xl: 12, children: /* @__PURE__ */ e(
      Se,
      {
        message: "Error",
        description: "Product not found or failed to load details.",
        type: "error",
        showIcon: !0
      }
    ) }) })
  ] }) : /* @__PURE__ */ l(q, { children: [
    /* @__PURE__ */ e(K, {}),
    /* @__PURE__ */ e(z, {}),
    /* @__PURE__ */ e(M, { justify: "center", children: /* @__PURE__ */ l(Z, { xs: 24, sm: 22, md: 20, lg: 16, xl: 12, style: { padding: "20px" }, children: [
      /* @__PURE__ */ e(k.Title, { level: 3, children: "Product Details" }),
      /* @__PURE__ */ e(
        ee,
        {
          width: 250,
          src: n.imageUrl || "/default-product.png",
          alt: n.name,
          fallback: "/default-product.png"
        }
      ),
      /* @__PURE__ */ l(T, { bordered: !0, column: 1, size: "middle", style: { marginTop: "20px" }, children: [
        /* @__PURE__ */ e(T.Item, { label: "Name", children: n.name }),
        /* @__PURE__ */ e(T.Item, { label: "Brand", children: n.brandInfo.brandName }),
        /* @__PURE__ */ e(T.Item, { label: "Category", children: n.category || "N/A" }),
        /* @__PURE__ */ e(T.Item, { label: "Price", children: /* @__PURE__ */ l(k.Text, { strong: !0, style: { fontSize: "16px", color: "#1890ff" }, children: [
          "R ",
          n.price
        ] }) }),
        /* @__PURE__ */ e(T.Item, { label: "Stock", children: n.availableToSell || "Out of stock" }),
        /* @__PURE__ */ e(T.Item, { label: "Specifications", children: n.specifications && Object.keys(n.specifications).length > 0 ? Object.entries(n.specifications).map(([g, O]) => /* @__PURE__ */ e(
          T,
          {
            bordered: !0,
            column: 1,
            size: "small",
            style: { marginBottom: "10px" },
            children: /* @__PURE__ */ e(
              T.Item,
              {
                label: /* @__PURE__ */ e(k.Text, { strong: !0, children: g }),
                span: 3,
                children: O.map((s) => /* @__PURE__ */ l(k.Text, { style: { display: "block" }, children: [
                  s.key,
                  ": ",
                  s.value
                ] }, s.key))
              }
            )
          },
          g
        )) : /* @__PURE__ */ e(k.Text, { type: "secondary", children: "No specifications available" }) })
      ] }),
      /* @__PURE__ */ l("div", { style: b, children: [
        /* @__PURE__ */ e(
          te,
          {
            min: 1,
            max: n.availableToSell,
            value: i,
            "aria-label": "quantity-selector",
            onChange: (g) => g && m(Number(g))
          }
        ),
        /* @__PURE__ */ e(
          f,
          {
            type: "primary",
            "aria-label": `Add ${n.name} to cart`,
            disabled: p,
            onClick: () => d({ product: n, quantity: i }),
            children: "Add to Cart"
          }
        )
      ] })
    ] }) })
  ] });
}, sr = (t) => L({
  queryKey: ["deals", t],
  queryFn: async () => De(
    Object.fromEntries(
      Object.entries(t ?? {}).filter(([r, a]) => a !== void 0)
    )
  ),
  staleTime: 1e3 * 60 * 5
  // Cache for 5 minutes
}), dr = (t) => L({
  queryKey: ["deal", t],
  queryFn: async () => {
    if (!t) throw new Error("No deal ID provided");
    return await Fe(t);
  },
  enabled: !!t,
  // Only run query if dealId is provided
  staleTime: 1e3 * 60 * 10
  // Cache for 10 minutes
}), ur = () => {
  const t = D();
  return async () => {
    try {
      await t.invalidateQueries({ queryKey: ["deals"] }), y.success("Deals list refreshed.");
    } catch (r) {
      y.error(r instanceof Error ? r.message : "Failed to refresh deals.");
    }
  };
}, Bt = (t) => {
  const r = N({
    mutationFn: (o) => t.charge(o),
    onError: (o) => y.error(o.message)
  }), a = N({
    mutationFn: (o) => t.refund(o),
    onError: (o) => y.error(o.message)
  });
  return { charge: r, refund: a, getStatus: (o) => t.getStatus(o) };
}, mr = (t) => Bt(t);
export {
  z as Breadcrumbs,
  $e as Button,
  nr as Cart,
  Pt as CartItemRow,
  rr as CartProvider,
  _t as CartSummary,
  or as CheckoutFlow,
  Tt as CheckoutForm,
  Qe as CustomerForm,
  Jt as CustomerModal,
  Xt as CustomerTable,
  er as DealFilterForm,
  tr as DealsTable,
  jt as Drawer,
  K as Header,
  Ht as Input,
  Yt as Modal,
  ar as ProductCard,
  vt as ProductCardSkeleton,
  cr as ProductDetailsPage,
  It as ProductList,
  xt as ProductSearchForm,
  lr as ProductSearchPage,
  Zt as Select,
  Gt as Table,
  F as useCart,
  Wt as useCreateCustomer,
  Me as useCustomers,
  sr as useDeals,
  Ue as useDeleteCustomer,
  dr as useFindDeal,
  Bt as usePaymentAdapter,
  mr as usePeachPayments,
  Ot as useProductDetails,
  Ft as useProducts,
  ur as useRefreshDeals,
  ir as useRefreshProducts,
  Vt as useUpdateCustomer
};
//# sourceMappingURL=index.js.map
